export default [
  {
    uri: 'sync/inventory-item-types',
    keyPath: 'externalId',
    objectStoreName: 'Item Types',
    indexes: [
      'itemNumber',
      'alternativePart1',
      'alternativePart2',
      'parent',
      'serialNumber',
      'trackedItemType',
      'category',
      'status',
      'expirationDate',
      'lastModifiedTimestamp',
    ],
  },
  {
    uri: 'sync/assets',
    keyPath: 'externalId',
    objectStoreName: 'Assets',
    indexes: [
      'allocatedReadZone',
      'currentReadZone',
      'lastModifiedTimestamp',
      'name',
      'parent',
      'serialNumber',
      'trackedItemType',
      'category',
      'status',
      'expirationDate',
    ],
  },
]
